// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"09d149d4","727":"3deced9b"}[chunkId] + ".chunk.js";
};